import { useStore } from 'react-redux'
import { configureAndSendTag } from './analytics.utils'

const useConfigureAndSendTag = () => {
  const { getState } = useStore()

  return tag => {
    if (tag?.tagInfo?.tagDisabled === 'true') return
    configureAndSendTag(tag, getState())
  }
}

export default useConfigureAndSendTag
